import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { UploadWizardStoryComponent } from './wizard.component';
import { UploadWizardPhotoFilteringComponent } from './photoFiltering/photoFiltering.component';
import { UploadWizardCoverComponent } from './cover/cover.component';
import { UploadWizardDesignStyleComponent } from './designStyle/designStyle.component';
import { UploadWizardDecorationsComponent } from './decorations/decorations.component';
import { UploadWizardBookformatDensityComponent } from './bookformatDensity/bookformatDensity.component';
import { UploadWizardStickerDensityComponent } from './stickerDensity/stickerDensity.component';
import { SortablejsModule } from 'angular-sortablejs/dist';
import { DuplicatedImagesService } from './duplicated-images.service';

@NgModule({
  declarations: [
    UploadWizardStoryComponent,
    UploadWizardCoverComponent,
    UploadWizardPhotoFilteringComponent,
    UploadWizardDesignStyleComponent,
    UploadWizardDecorationsComponent,
    UploadWizardStickerDensityComponent,
    UploadWizardBookformatDensityComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    SortablejsModule,
  ],
  providers: [DuplicatedImagesService],
})
export class WizardModule {}
